const { default: CommonServices } = require("./common/common");

class QuoteManagementService extends CommonServices {
  constructor() {
    super("/banners/quote");
  }
}

const quoteManagementService = new QuoteManagementService();
export default quoteManagementService;
